import React from 'react'

const Header = () => {
  return (
    <header className="App-header">
        Rich Text Editor
      </header>
  )
}

export default Header